import { useTranslation } from 'react-i18next'
import { deleteKiosk, updateKiosk } from '../../../../services/templeKioskService'
import useNotifications from '../../../../hooks/useNotifications'

export default function useKioskDetails({ kiosksState, kiosksActions, editableFieldsRef, deleteKioskOverlay }) {
  const { t } = useTranslation()
  const { ok, error } = useNotifications()

  const handleSaveChanges = () => {
    editableFieldsRef.current.authorized =
      editableFieldsRef.current.authorized === 'true' || editableFieldsRef.current.authorized === true
    updateKiosk(kiosksState.selectedKiosk.kioskId, { ...kiosksState.selectedKiosk, ...editableFieldsRef.current })
      .then(() => {
        kiosksActions.setKiosks((prev) => [
          ...prev.filter((kiosk) => kiosk.kioskId !== kiosksState.selectedKiosk.kioskId),
          { ...kiosksState.selectedKiosk, ...editableFieldsRef.current },
        ])
        kiosksActions.setKioskSuggestions((prev) => [
          ...prev.filter((suggestion) => suggestion.secondaryText !== kiosksState.selectedKiosk.kioskId),
          {
            primaryText: `${editableFieldsRef.current.templeCode} - ${editableFieldsRef.current.locationDescription}`,
            secondaryText: kiosksState.selectedKiosk.kioskId,
            authorized: editableFieldsRef.current.authorized,
          },
        ])
        kiosksActions.setSelectedKiosk((prev) => ({ ...prev, ...editableFieldsRef.current }))
        kiosksActions.setKioskInputText(
          `${editableFieldsRef.current.templeCode} - ${editableFieldsRef.current.locationDescription}`
        )
        kiosksActions.setIsEditMode(false)
        ok(t('temple.kiosk.updateKiosk.success', 'Kiosk updated successfully'))
      })
      .catch((err) => {
        error(
          t('temple.kiosk.updateKiosk.error', `Error saving kiosk: {message}`, {
            message: err.response?.data?.notifications?.[0]?.msg || err.message,
          })
        )
      })
  }

  const handleDeleteKiosk = () => {
    deleteKioskOverlay.close()
    deleteKiosk(kiosksState.selectedKiosk.kioskId)
      .then(() => {
        kiosksActions.setKiosks((prev) => [
          ...prev.filter((kiosk) => kiosk.kioskId !== kiosksState.selectedKiosk.kioskId),
        ])
        kiosksActions.setKioskSuggestions((prev) => [
          ...prev.filter((suggestion) => suggestion.secondaryText !== kiosksState.selectedKiosk.kioskId),
        ])
        kiosksActions.setSelectedKiosk(null)
        kiosksActions.setKioskInputText('')
        ok(t('temple.kiosk.deleteKiosk.success', 'Kiosk deleted successfully'))
        kiosksActions.setIsEditMode(false)
      })
      .catch((err) => error(t('temple.kiosk.deleteKiosk.error', 'Error deleting kiosk'), err))
  }

  return { handleSaveChanges, handleDeleteKiosk }
}
